module.exports = "<a [href]=\"linkUrl\" target=\"_blank\"><img [src]=\"imageUrl\" [width]=\"imgWidth\"></a>"